import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DocIcon } from './DocIcon';

// Hamburger shown on small screens to open the off-canvas sidebar
export const NavToggleButton = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Box
      component="button"
      title={t('Topics')}
      onClick={onClick}
      className="items-center justify-center cursor-pointer inline-flex md:hidden"
      sx={{
        border: '1px solid var(--border)',
        background: 'var(--panel)',
        color: 'var(--text2)',
        borderRadius: '8px',
        width: '30px',
        height: '30px',
        marginRight: '2px',
      }}
    >
      <DocIcon name="menu" size={18} />
    </Box>
  );
};
